import { Traveler } from './../../shared';
import { ApiPolicyGetForEditResponse, ApiEditTraveler } from '@bhtp-client-api/edit';

export class TravelersData {
    public primaryTraveler: Traveler;
    public additionalTravelers: Array<Traveler>;

    public static createTravelersData(apiResponse: ApiPolicyGetForEditResponse): TravelersData {
        let travelersData: TravelersData = new TravelersData();

        apiResponse.travelers.forEach((traveler: ApiEditTraveler) => {
            let newTraveler: Traveler = Traveler.fromApiEditTraveler(traveler);

            if (traveler.isPrimary) {
                travelersData.primaryTraveler = newTraveler;
            } else {
                travelersData.additionalTravelers.push(newTraveler);
            }
        });

        return travelersData;
    }

    public static getAllTravelers(travelerData: TravelersData): Array<Traveler> {
        let travelers: Array<Traveler> = new Array<Traveler>();
        travelerData.primaryTraveler.isPrimary = true;
        travelers.push(travelerData.primaryTraveler);
        travelers = travelers.concat(travelerData.additionalTravelers);
        return travelers;
    }

    constructor() {
        this.primaryTraveler = new Traveler(true);
        this.additionalTravelers = new Array<Traveler>();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/policy-edit/view-models/travelers-data.model.ts